import * as React from "react";
function SvgSliders(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44 44"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth={3}
        strokeLinecap="round"
      >
        <circle cx={18} cy={10} r={4.5} />
        <circle cx={34} cy={22} r={4.5} />
        <circle cx={10} cy={34} r={4.5} />
        <path d="M1.5 10h12m-12 12h28m-28 12H5m34-12h3.5M15 34h27.5M23 10h19.5" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSliders);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
